import { MasterGroup, ResponseStatus } from "@/api/dtos";
import { createContext } from "react"

export interface IMasterGroupContext {
    data?: MasterGroup;
    error?: ResponseStatus;
    loading: boolean;
    validating: boolean;
    refresh: () => Promise<MasterGroup | undefined>
}

export const MasterGroupContext = createContext<IMasterGroupContext>({
    loading: false,
    validating: false,
    data: undefined,
    error: undefined,
    refresh: () => {
        return new Promise<MasterGroup | undefined>(res => {
            res(undefined);
        });
    }
});

export default MasterGroupContext;